/*
	Fecha o configurador de charts
*/
export default (state) => {
	state.ChartConfigurator.isOpen 		= false
	state.ChartConfigurator.chartState 	= undefined
}
	
	
